import { computed, ref, type Ref } from "vue"
import { defineStore } from "pinia"
import type { WorkspaceAudienceGroup } from "@/workspace/models/workspace-audience-group.model"
import type { WorkspaceNote } from "@/workspace/models/workspace-note.model"

export const useWorkspaceStore = defineStore("workspaceStore", () => {
  // Every note the socket or a fetch hands us; useWorkspaceData() filters what the active planner may see.
  const notes: Ref<WorkspaceNote[]> = ref([])
  // Groups are shared by the whole tenant, archived ones included.
  const audienceGroups: Ref<WorkspaceAudienceGroup[]> = ref([])
  const workspaceFetched = ref(false)
  const workspaceLoading = ref(false)

  const activeAudienceGroups = computed(() =>
    audienceGroups.value.filter((group) => group.archivedAt === null)
  )

  function clearWorkspace() {
    notes.value = []
    audienceGroups.value = []
    workspaceFetched.value = false
    workspaceLoading.value = false
  }

  return {
    notes,
    audienceGroups,
    activeAudienceGroups,
    workspaceFetched,
    workspaceLoading,
    clearWorkspace
  }
})
